import Controller from './root.controller'

export default [
  '$window',
  '$rootScope',
  'tabService',
  'storyService',
  ($window, $rootScope, tabService, storyService) => ({
    restrict: 'EA',
    controller: Controller,
    link: (scope, elem, attrs) => {
      setTimeout(() => {
        const isFindAndReplace = (e) =>
          e.which === 70 && (e.ctrlKey || e.metaKey)
        $window.addEventListener('keydown', (e) => {
          if (isFindAndReplace(e)) {
            if (tabService.getActiveTabId() === 'tab-compose') {
              $rootScope.$broadcast('TOGGLE_FIND_REPLACE', {})
              e.preventDefault()
              return false
            }
          }
        })
      })
    },
  }),
]
